import React from "react";
import { Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="ws-footer" data-no-i18n="true">
      <div className="ws-footer__inner">
        <div className="ws-footer__brand-column">
          <Link className="ws-footer__brand" to="/">
            WonyaSoft
          </Link>
          <p>{t("Solutions monétiques")}</p>
          <div className="ws-footer__contact-line">
            <MapPin size={17} aria-hidden="true" />
            <span>
              <strong className="ws-footer__office-title">{t("Siège")}</strong>{" "}
              : Kolwezi, RDC
            </span>
          </div>
          <div className="ws-footer__contact-line">
            <MapPin size={17} aria-hidden="true" /> Lubumbashi, RDC
          </div>
          <a
            className="ws-footer__contact-line"
            href="mailto:contact@wonyasoft.com"
          >
            <Mail size={17} aria-hidden="true" /> contact@wonyasoft.com
          </a>
        </div>

        <nav className="ws-footer__column" aria-label={t("Nos solutions")}>
          <h2>{t("Nos solutions")}</h2>
          <Link to="/solutions#api-wonyapay">
            {t("Projet Développeur | API WonyaPay")}
          </Link>
          <Link to="/appmobile">{t("Nos applications")}</Link>
          <Link to="/business">{t("Inscription Business")}</Link>
        </nav>

        <nav className="ws-footer__column" aria-label={t("Liens utiles")}>
          <h2>{t("Liens utiles")}</h2>
          <Link to="/compliance">{t("Conformité")}</Link>
          <Link to="/terms">{t("Termes et conditions")}</Link>
          <Link to="/privacy">{t("Politique de confidentialité")}</Link>
          <Link to="/blog">{t("Articles")}</Link>
          <Link to="/testimonials">{t("Témoignages")}</Link>
          <Link to="/clients">{t("Nos clients")}</Link>
        </nav>

        <div className="ws-footer__column ws-footer__cta-column">
          <h2>{t("Construisons votre prochain parcours de paiement")}</h2>
          <p>
            {t(
              "Notre équipe vous accompagne du cadrage jusqu’à l’intégration et la mise en production.",
            )}
          </p>
          <Link className="ws-footer__button" to="/contact">
            {t("Contactez-nous")}
          </Link>
        </div>
      </div>
      <div className="ws-footer__bottom">
        <span>
          © {new Date().getFullYear()} WonyaSoft. {t("Tous droits réservés.")}
        </span>
        <span>WONYA SOFT S.A · RDC</span>
      </div>
    </footer>
  );
};

export default Footer;
